module.exports = __webpack_public_path__ + "static/img/leiniao_member_bg.ab835255.png";